export default {
  BookkeepingBtnClosedMonthAdd: 'BookkeepingBtnClosedMonthAdd',
  BookkeepingBtnClosedMonthOpenMonth: 'BookkeepingBtnClosedMonthOpenMonth',
  BookkeepingBtnClosedMonthRecloseMonth: 'BookkeepingBtnClosedMonthRecloseMonth',
  BookkeepingBtnClosedMonthSendInformationToTheClient: 'BookkeepingBtnClosedMonthSendInformationToTheClient',
  BookkeepingBtnClosedMonthTaxesInfo: 'BookkeepingBtnClosedMonthTaxesInfo',
  BookkeepingBtnDeclarationsCorrectVatDeclaration: 'BookkeepingBtnDeclarationsCorrectVatDeclaration',
  BookkeepingBtnDeclarationsDelete: 'BookkeepingBtnDeclarationsDelete',
  BookkeepingBtnDeclarationsDownloadHubsign: 'BookkeepingBtnDeclarationsDownloadHubsign',
  BookkeepingBtnDeclarationsDownloadXml: 'BookkeepingBtnDeclarationsDownloadXml',
  BookkeepingBtnDeclarationsVatAddDeclaration: 'BookkeepingBtnDeclarationsVatAddDeclaration',
  BookkeepingBtnDeclarationsVatPrint: 'BookkeepingBtnDeclarationsVatPrint',
  BookkeepingBtnDeclarationsVatPrintUPO: 'BookkeepingBtnDeclarationsVatPrintUPO',
  BookkeepingBtnDeclarationsVatRefresh: 'BookkeepingBtnDeclarationsVatRefresh',
  BookkeepingBtnDeclarationsVatSignAndSend: 'BookkeepingBtnDeclarationsVatSignAndSend',
  BookkeepingBtnDeclarationsPitSignAndSend: 'BookkeepingBtnDeclarationsPitSignAndSend',
  BookkeepingBtnEvidencesAdd: 'BookkeepingBtnEvidencesAdd',
  BookkeepingBtnEvidencesCalculateExchangeRateDifferences: 'BookkeepingBtnEvidencesCalculateExchangeRateDifferences',
  BookkeepingBtnEvidencesDelete: 'BookkeepingBtnEvidencesDelete',
  BookkeepingBtnEvidencesEdit: 'BookkeepingBtnEvidencesEdit',
  BookkeepingBtnEvidencesExportToSymfonia: 'BookkeepingBtnEvidencesExportToSymfonia',
  BookkeepingBtnEvidencesFiles: 'BookkeepingBtnEvidencesFiles',
  BookkeepingBtnEvidencesInternalEvidence: 'BookkeepingBtnEvidencesInternalEvidence',
  BookkeepingBtnEvidencesPreview: 'BookkeepingBtnEvidencesPreview',
  BookkeepingBtnEvidencesPrintInternalEvidences: 'BookkeepingBtnEvidencesPrintInternalEvidences',
  BookkeepingBtnInvoiceExportToSymfonia: 'BookkeepingBtnInvoiceExportToSymfonia',
  BookkeepingBtnInvoiceBookToEvidences: 'BookkeepingBtnInvoiceBookToEvidences',
  BookkeepingBtnVehiclesAdd: 'BookkeepingBtnVehiclesAdd',
  BookkeepingBtnVehiclesDelete: 'BookkeepingBtnVehiclesDelete',
  BookkeepingBtnVehiclesEdit: 'BookkeepingBtnVehiclesEdit',
  BookkeepingBtnZusCompanySettlementsGoToList: 'BookkeepingBtnZusCompanySettlementsGoToList',

  BookkeepingFormEvidencesEditable: 'BookkeepingFormEvidencesEditable',

  BookkeepingPageClosedMonthAdd: 'BookkeepingPageClosedMonthAdd',
  BookkeepingPageClosedMonthEdit: 'BookkeepingPageClosedMonthEdit',
  BookkeepingPageClosedMonthList: 'BookkeepingPageClosedMonthList',
  BookkeepingPageClosedMonthTaxesInfo: 'BookkeepingPageClosedMonthTaxesInfo',
  BookkeepingPageDeclarationsPitList: 'BookkeepingPageDeclarationsPitList',
  BookkeepingPageDeclarationsVatList: 'BookkeepingPageDeclarationsVatList',
  BookkeepingPageEvidencesAdd: 'BookkeepingPageEvidencesAdd',
  BookkeepingPageEvidencesClosedMonthAdd: 'BookkeepingPageEvidencesClosedMonthAdd',
  BookkeepingPageEvidencesClosedMonthList: 'BookkeepingPageEvidencesClosedMonthList',
  BookkeepingPageEvidencesEdit: 'BookkeepingPageEvidencesEdit',
  BookkeepingPageEvidencesList: 'BookkeepingPageEvidencesList',
  BookkeepingPageEvidencesAllList: 'BookkeepingPageEvidencesAllList',
  BookkeepingPageEvidencesPrints: 'BookkeepingPageEvidencesPrints',
  BookkeepingPageInvoicesAdd: 'BookkeepingPageInvoicesAdd',
  BookkeepingPageInvoicesCorrectionAdd: 'BookkeepingPageInvoicesCorrectionAdd',
  BookkeepingPageInvoicesCorrectionEdit: 'BookkeepingPageInvoicesCorrectionEdit',
  BookkeepingPageInvoicesEdit: 'BookkeepingPageInvoicesEdit',
  BookkeepingPageInvoicesKlaEdit: 'BookkeepingPageInvoicesKlaEdit',
  BookkeepingPageInvoicesKlaList: 'BookkeepingPageInvoicesKlaList',
  BookkeepingPageInvoicesPaymentDueList: 'BookkeepingPageInvoicesPaymentDueList',
  BookkeepingPageInvoicesList: 'BookkeepingPageInvoicesList',
  BookkeepingPageVehiclesAdd: 'BookkeepingPageVehiclesAdd',
  BookkeepingPageVehiclesEdit: 'BookkeepingPageVehiclesEdit',
  BookkeepingPageVehiclesList: 'BookkeepingPageVehiclesList',
  BookkeepingPageZusCompanySettlementsAdd: 'BookkeepingPageZusCompanySettlementsAdd',
  BookkeepingPageZusCompanySettlementsEdit: 'BookkeepingPageZusCompanySettlementsEdit',
  BookkeepingPageZusCompanySettlementsList: 'BookkeepingPageZusCompanySettlementsList',
  BookkeepingPageFixedAssetsAdd: 'BookkeepingPageFixedAssetsAdd',
  BookkeepingPageFixedAssetsEdit: 'BookkeepingPageFixedAssetsEdit',
  BookkeepingPageFixedAssetsList: 'BookkeepingPageFixedAssetsList',
  BookkeepingPageFixedAssetsToEvidence: 'BookkeepingPageFixedAssetsToEvidence',

  BookkeepingBookInvoicesButton: 'BookkeepingBookInvoicesButton',

  BookkeepingEvidenceStatusColumn: 'BookkeepingEvidenceStatusColumn',

  BookkeepingPageDeclarationsPackagesList: 'BookkeepingPageDeclarationsPackagesList',

  BookkeepingInvoicesAccessAll: 'BookkeepingInvoicesAccessAll',
  BookkeepingEvidencesAccessAll: 'BookkeepingEvidencesAccessAll',
};
